import React from "react"
import { Button, Empty, Space } from "antd"
import useQueryParams from "../../hooks/useQueryParams"
import { isTodayRange, periodInterval, DefaultPeriod } from "../../utils/defaultPeriod"

// Tog'a #342 (katalog #6024) / #438: sukut davri «Сегодня» — bo'sh ro'yxatda «За сегодня записей нет» va davrni kengaytirish tugmalari.
// URL'dagi begin/end aynan bugun bo'lsagina ishlaydi (boshqa davrda — antd'ning odatiy «Нет данных»).
export function TodayEmptyBody({ onWiden }: { onWiden: (p: DefaultPeriod) => void }) {
  return (
    <div data-testid="today-empty">
      <div style={{ marginBottom: 8 }}>За сегодня записей нет</div>
      <Space wrap>
        <Button size="small" onClick={() => onWiden("week")} data-testid="today-empty-week">Показать за неделю</Button>
        <Button size="small" onClick={() => onWiden("month")} data-testid="today-empty-month">за месяц</Button>
      </Space>
    </div>
  )
}

/** URL davri bugun bo'lsa — bo'sh holat matni (MobileCards uchun) va to'liq Empty (antd Table locale.emptyText uchun); aks holda null */
export function useTodayEmpty(): { description: React.ReactNode; element: React.ReactNode } | null {
  const query = useQueryParams()
  if (!isTodayRange(query.get("begin"), query.get("end"))) return null
  const kengay = (p: DefaultPeriod) => { const { begin, end } = periodInterval(p); query.append({ begin, end }) }
  const description = <TodayEmptyBody onWiden={kengay} />
  return { description, element: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} /> }
}
